/* eslint-disable  */
import LicenseEditableTable from './LicenseEditableTable'

export default LicenseEditableTable;


// WEBPACK FOOTER //
// ./src/legacy/containers/Tables/LicenseEditableTable/index.js